import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const CtnBlock = ({ ctn, imageUrl }) => (
  <div className={cn('block')}>
    <div className={cn('block__image-wrapper')}>
      <img src={imageUrl} alt="" className={cn('block__image')} />
    </div>
    <div className={cn('block__cell-number')}>
      <Text
        color="grey95"
        size="size3-m"
      >
        {ctn}
      </Text>
    </div>
  </div>
);

CtnBlock.propTypes = {
  ctn: PropTypes.string,
  imageUrl: PropTypes.string,
};

export { CtnBlock };
